import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import DataTableBodyCell from "./DataTableBodyCell";
import DataTableSelectionCell from "./DataTableSelectionCell";
import { columnPropType } from "./propTypes";
import * as ColumnType from "./ColumnType";
export default class DataTableBodyRow extends PureComponent {
  static propTypes = {
    columns: PropTypes.arrayOf(columnPropType).isRequired,
    row: PropTypes.object.isRequired,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
    onSelectionChange: PropTypes.func,
  };
  handleClick = () => {
    const { row, onClick } = this.props;

    if (onClick) {
      onClick(row);
    }
  };
  renderCell = (column, index) => {
    const { name, type, clickDisabled } = column;
    const { row, selected, onSelectionChange } = this.props;

    if (type === ColumnType.SELECTION) {
      return (
        <DataTableSelectionCell key={index} column={column} row={row} value={selected} onChange={onSelectionChange} />
      );
    }

    return (
      <DataTableBodyCell key={index} column={column} row={row} onClick={clickDisabled ? undefined : this.handleClick} />
    );
  };

  render() {
    const { columns, row, selected, onClick, onSelectionChange, ...otherProps } = this.props;
    return <tr {...otherProps}>{columns.map((item, index) => this.renderCell(item, index))}</tr>;
  }
}
